import { render, staticRenderFns } from "./RequestsList.vue?vue&type=template&id=a4af9f5e&scoped=true"
import script from "./RequestsList.vue?vue&type=script&lang=js"
export * from "./RequestsList.vue?vue&type=script&lang=js"
import style0 from "./RequestsList.vue?vue&type=style&index=0&id=a4af9f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4af9f5e",
  null
  
)

export default component.exports